import React from 'react';
import { ContentContainer } from '@tmobile/tmo-bps-syncup-web-component-lib';

import Authorized from '../../auth/Authorized';
import { SUA_ROLES } from '../../utils/app_constants';
import Unclaim from '../../components/Unclaim';
import PageHeader from 'components/uiHelpers/pageHeader/PageHeader';

import style from './BulkUnclaim.module.css';

/**
 * BulkUnclaim Page
 *
 * Renders the Bulk Unclaim workflow inside an authorization wrapper.
 * Only Admin and Supply Chain roles are allowed to access this page.
 *
 * Structure:
 *  - Authorization Guard --> ensures user role permissions
 *  - Content Container   --> applies global layout styling
 *  - Page Header         --> displays the page title
 *  - Unclaim Component   --> handles bulk unclaim functionality
 */
function BulkUnclaim({ match: { url } }) {
  return (
    <Authorized
      // Allow only Admin & Supply Chain roles to access the page
      roles={[SUA_ROLES.ADMIN, SUA_ROLES.SUPPLY_CHAIN]}
      // Display error modal automatically if access is denied
      willShowErrorModal
    >
      {/* Main layout wrapper for consistent page structure */}
      <ContentContainer>
        {/* Page title */}
        <PageHeader title={'Bulk Unclaim'} />

        {/* Page-specific content wrapper */}
        <div className={style.content}>
          {/* Handles the actual Bulk Unclaim logic/UI */}
          <Unclaim />
        </div>
      </ContentContainer>
    </Authorized>
  );
}

export default BulkUnclaim;
